<template>
  <div
    class="text-agentnoon-primary-700 ml-auto flex h-6 items-center justify-center gap-1 rounded-full bg-bluedark-50 px-2 text-sm font-medium bg-blend-multiply"
  >
    View
  </div>
</template>
